<template>
	<div id="patient-card" class="card p-2">
		<div class="fullname">{{ patient.firstName }} {{ patient.lastName }}</div>
		<template v-if="patient.lastMeasurementRecord === undefined">
			<div class="empty">Aún no hay datos de sensor de paciente</div>
		</template>
		<template v-else>
			<div class="last-measure time">
				{{ formatDateTime(patient.lastMeasurementRecord.dateTime.toDate()) }}
			</div>
			<div class="last-measure data">
				<span>
					<i class="far fa-heart"></i>
					{{ formatDecimalValue(patient.lastMeasurementRecord.frecResp) }}
				</span>
				<span>
					<i class="far fa-heart"></i>
					{{ formatDecimalValue(patient.lastMeasurementRecord.frecCard) }}
				</span>
				<span>
					<i class="far fa-heart"></i> {{ formatDecimalValue(patient.lastMeasurementRecord.satO2) }}
				</span>
				<span>
					<i class="far fa-heart"></i> {{ formatDecimalValue(patient.lastMeasurementRecord.temp) }}
				</span>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
	import { formatDateTime, formatDecimalValue } from "@/domain/entities/EntityFields";
	import { defineComponent } from "vue";

	export default defineComponent({
		name: "patient-card",
		props: {
			patient: Object,
		},
		setup() {
			return {
				formatDateTime,
        formatDecimalValue,
			};
		},
	});
</script>

<style lang="stylus" scoped>
@import '../styles/layout.styl';

	#patient-card {
		cursor: pointer;
		display: grid;
		grid-template-columns: widthFixedColumnMobile auto;

		@media screen and (min-width: 500px) {
			grid-template-columns: widthFixedColumn widthFixedColumn auto;
		}
	}

	.empty {
		grid-column: span 2;
	}

	.last-measure.data {
		display: grid !important;
		grid-template-columns: auto auto auto auto;

		@media screen and (max-width: 500px) {
			grid-template-rows: auto auto;
			grid-template-columns: auto auto;
		}
	}

	.last-measure.time {
		@media screen and (max-width: 500px) {
			display: none;
		}
	}
</style>
